import { Component, OnInit } from '@angular/core';
import { GO_INIT } from '@core/state/action-types';
import { IAppState } from '@core/state/app/app-state';
import { Store } from '@ngrx/store';

@Component({
    selector: 'pay-go',
    template: '',
})

/**
 * Empty view component.. used to trigger API calls.
 * Used to trigger an effect call on page startups.
 *
 */
export class GoComponent implements OnInit {
    constructor(private store$: Store<IAppState>) {}

    ngOnInit() {
        this.store$.dispatch({ type: GO_INIT });
    }
}